import { PropsWithChildren } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/Common/UI/Card';
import { cn } from '../../../../utils/styles';

export type IContentCardTitleSize = 'default' | 'small';

interface IContentCard extends PropsWithChildren {
  icon?: React.ReactNode;
  title: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  titleSize?: IContentCardTitleSize;
  className?: string;
  titleStyle?: string;
  actions?: React.ReactNode;
}

function ContentCard({ title, children, className, icon, titleSize, titleStyle, actions, subTitle }: IContentCard) {
  return (
    <Card className={cn('bg-white rounded-[10px] relative z-[5] p-[20px] pb-[30px] border-0 shadow-lg', className)}>
      <CardHeader className="p-0">
        <CardTitle className={cn('flex gap-[20px] items-center justify-between mb-[30px] flex-wrap', titleStyle)}>
          <div>
            <div className="flex gap-[20px] items-center">
              {icon || null}
              <div className={cn('font-bold text-xl', { 'text-[18px]': titleSize === 'small' })}>{title}</div>
            </div>
            {subTitle ? <div className="opacity-50 text-[12px] leading-[15px] font-normal">{subTitle}</div> : null}
          </div>
          <div className="flex gap-[10px] flex-wrap justify-center">{actions}</div>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  );
}

ContentCard.defaultProps = {
  className: '',
  actions: undefined,
  icon: undefined,
  subTitle: '',
  titleStyle: '',
  titleSize: 'default',
};

export default ContentCard;
